import './CarrotToggle.scss';

import { bool, func, node, string } from 'prop-types';
import React, { Fragment, useState } from 'react';
import { ReactComponent as CarrotDown } from 'assets/icons/chevron-down.svg';
import { ReactComponent as CarrotUp } from 'assets/icons/chevron-up.svg';

const CarrotToggle = ({
  isOpen = null,
  toggleChildrenView,
  viewChildren = false,
  label = '',
  labelClass = '',
  btnClass = '',
  children
}) => {
  const [show, setShow] = useState(viewChildren);

  const view = isOpen !== null ? isOpen : show;

  const toggle = () => {
    toggleChildrenView && toggleChildrenView();
    setShow(!show);
  };

  return (
    <Fragment>
      <div>
        <button
          onClick={toggle}
          className={`show-hide-toggle-icon toggle-carrot ${btnClass}`}>
          {view ? (
            <CarrotUp className="toggle-carrot-icon" />
          ) : (
            <CarrotDown className="toggle-carrot-icon" />
          )}
          {label && (
            <span className={labelClass}>
              {view ? ' Hide ' : ' View '}
              {label}
            </span>
          )}
        </button>
      </div>
      {view && children}
    </Fragment>
  );
};

CarrotToggle.propTypes = {
  viewChildren: bool,
  toggleChildrenView: func,
  label: string,
  labelClass: string,
  children: node
};

export default CarrotToggle;
